import { MenuItem } from '@/store/menu/menu';
import { configModule } from '@/store/config';
import { PagePaths } from '@/store/application/page.definitions';

export const settingsItems: MenuItem[] = [
  {
    meta: {
      permissions: ['ffsecurity.view_runtimesetting']
    },
    name: 'settings',
    i18n: 'common.general',
    path: PagePaths.Settings
  },
  {
    meta: {},
    name: 'interface',
    i18n: 'common.interface',
    path: PagePaths.Interface
  },
  {
    meta: {
      permissions: ['ffsecurity.view_user']
    },
    name: 'roles',
    i18n: 'common.roles',
    path: PagePaths.Roles
  },
  {
    meta: {
      permissions: ['ffsecurity.view_user']
    },
    name: 'users',
    i18n: 'common.users',
    path: PagePaths.Users
  },
  {
    meta: {},
    name: 'sessions',
    i18n: 'common.sessions',
    path: PagePaths.Sessions
  },
  {
    meta: {
      permissions: ['ffsecurity.view_deviceblacklistrecord']
    },
    name: 'blocklistRecords',
    i18n: 'common.blocklist_records',
    path: PagePaths.BlockList
  },
  {
    meta: {
      permissions: ['ffsecurity.view_cameragroup']
    },
    name: 'camera-groups',
    i18n: 'common.camera_groups',
    path: PagePaths.CameraGroups
  },
  {
    meta: {
      permissions: ['ffsecurity.view_watchlist']
    },
    name: 'watch-lists',
    i18n: 'common.watch_lists',
    path: PagePaths.WatchLists
  },

  {
    meta: {
      permissions: ['ffsecurity.configure_ntls']
    },
    name: 'license',
    i18n: 'common.license',
    path: PagePaths.License
  },
  {
    meta: {
      permissions: ['ffsecurity.view_externalvms']
    },
    name: 'external-vms',
    i18n: 'common.external_vms',
    path: PagePaths.ExternalVms,
    enabled: () => {
      return configModule.config.external_vms?.enabled;
    }
  },
  {
    name: 'developer',
    i18n: 'common.developer',
    meta: {
      permissions: ['ffsecurity.view_webhook', 'ffsecurity.view_user'],
      plugins: {
        partner: false
      }
    }
  },
  {
    meta: {
      services: {
        webhooks: true
      },
      permissions: ['ffsecurity.view_webhook']
    },
    name: 'hooks',
    i18n: 'webhooks.webhooks',
    path: PagePaths.Hooks
  },
  {
    meta: {},
    name: 'documentation',
    i18n: 'common.documentation',
    external: true,
    serverPath: 'doc/'
  },
  {
    meta: {},
    name: 'api_doc',
    i18n: 'common.documentation_api',
    external: true,
    serverPath: 'api-docs/'
  }
];
